<template>
	<div class="box">
		<picture class="box_bg">
			<source :srcset="bgPc" media="(min-width: 1161px)" />
			<img :src="bgSp" alt="" />
		</picture>
		<h2 class="box_title u-font-ots">{{ title }}</h2>
	</div>
</template>

<script>
export default {
	name: 'bg-title-box',
	props: {
		bgPc: String,
		bgSp: String,
		title: String,
	},
};
</script>

<style lang="scss" scoped>
.box {
	margin-top: 3em;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 100%;
	height: 58.67vw;
	@media screen and (min-width: 1161px) {
		margin-top: 120px;
		height: 320px;
	}
	&_bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	&_title {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		position: relative;
		z-index: 1;
		width: 266px;
		padding: 1em 0;
		border: 1px solid #fff;
		color: #fff;
		font-size: 12px;
		letter-spacing: 0.1em;
		box-sizing: border-box;
		@media screen and (min-width: 1161px) {
			width: 380px;
			letter-spacing: 0.05em;
			font-size: 18px;
		}
	}
}
</style>
